import React, { createContext, useMemo } from 'react';
import { useContext } from '../utils/useContext';
import { createUseValidationHook } from '../utils/useValidation';
import { Context as CartContext } from './Cart';
export const Context = createContext(undefined);
Context.displayName = 'StoreCartValidatorContext';
const useValidation = createUseValidationHook();
export const OptimisticProvider = ({ children, onValidateCart, }) => {
    const { items, id, setCart } = useContext(CartContext);
    const cart = useMemo(() => ({ id, items }), [id, items]);
    const isValidating = useValidation({
        onValidate: onValidateCart,
        value: cart,
        setValue: setCart,
    });
    return React.createElement(Context.Provider, { value: isValidating }, children);
};
//# sourceMappingURL=Optimistic.js.map